
export const testimonials = [
  {
    id: 1,
    name: 'Sarah C.',
    neighborhood: 'West Roseville',
    years: 7,
    quote: 'Moving from San Francisco, I was worried about losing that city energy. But Roseville surprised me — the community here is incredibly welcoming, the schools are top-rated, and we actually have a backyard now. Best decision we ever made for our family.',
    rating: 5,
    highlight: 'Family-Friendly',
  },
  {
    id: 2,
    name: 'Marcus J.',
    neighborhood: 'Old Town Roseville',
    years: 12,
    quote: 'I\'ve watched Old Town transform over the past decade. The craft breweries, the farmers market on Saturdays, the live music scene — it\'s become this vibrant hub while still keeping that small-town charm. I wouldn\'t trade my morning coffee walks for anything.',
    rating: 5,
    highlight: 'Culture & Dining',
  },
  {
    id: 3,
    name: 'Emily R.',
    neighborhood: 'Sierra Vista',
    years: 4,
    quote: 'As a remote worker, Roseville is perfect. Great coffee shops to work from, reliable internet, and when I close my laptop I\'m 20 minutes from hiking trails and 90 minutes from Tahoe. The cost of living compared to the Bay Area is night and day.',
    rating: 5,
    highlight: 'Remote Work Life',
  },
  {
    id: 4,
    name: 'David & Lisa P.',
    neighborhood: 'Woodcreek Oaks',
    years: 9,
    quote: 'We raised both our kids here and couldn\'t imagine a better place. The parks are immaculate, the youth sports programs are fantastic, and the neighbors genuinely look out for each other. It feels like the kind of community you see in movies.',
    rating: 5,
    highlight: 'Community Spirit',
  },
  {
    id: 5,
    name: 'Tom B.',
    neighborhood: 'Granite Bay',
    years: 15,
    quote: 'After retiring, my wife and I explored dozens of cities. Roseville won us over with its 265 sunny days, world-class healthcare at Sutter and Kaiser, and the incredible trail system. We bike Miners Ravine Trail every morning — it never gets old.',
    rating: 5,
    highlight: 'Active Retirement',
  },
  {
    id: 6,
    name: 'Priya S.',
    neighborhood: 'Sun City',
    years: 3,
    quote: 'The diversity here is something people don\'t expect. We found an amazing Indian grocery store, our kids\' school celebrates every culture, and the tech job market is booming with companies moving to the Sacramento region. Roseville is truly the hidden gem of NorCal.',
    rating: 5,
    highlight: 'Diversity & Jobs',
  },
];
